// Path normalisation before an event leaves the browser. Server double-strips.

import { UUID_RE } from './config'

/**
 * Replace any UUID segment with `:id`, drop the query string, drop a trailing
 * slash (except for the root). Keeps grouping meaningful in Grafana:
 *   /workspace/queue/<uuid>?foo=bar  →  /workspace/queue/:id
 *   /clients/<uuid>/facilities?x=1   →  /clients/:id/facilities
 */
export function normalisePath(pathname: string, search?: string): string {
  const path = pathname.split('?')[0].replace(UUID_RE, ':id')
  // Drop trailing slash (but not for `/`).
  const trimmed = path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path
  // Preserve the `?tab=` on /search — it's the only search-string signal we
  // want to keep. Everything else is dropped.
  if (search && (trimmed === '/search' || trimmed.startsWith('/search/'))) {
    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
    const tab = params.get('tab')
    if (tab) return `${trimmed}?tab=${tab}`
  }
  return trimmed
}
